<!-- @Description AI4Science-Al+医疗器械产品矩阵 -->
<template>
  <van-collapse v-model="activeName" accordion class="productmatrix">
    <van-collapse-item
      title="基于AI的认知智能评估机"
      name="1"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '1' }"
    >
      <div class="info">
       
        <ul style="padding-left: 20px; list-style-type: disc;">
          <li>面向神经科室日常接诊中需求设计的认知评估设备，内置MMSE、Moca-B、韦氏等认知评估量表。</li>
          <li>仪器根据认知评估量表，通过视频、文图和语音等方式与就诊患者进行交互式问诊</li>
          <li>采集全部的视频和音频数据进行AI分析，并评估打分。提供医生评估测试结果，帮助医生进行诊断。</li>
        </ul>
      </div>
      <img
        v-if="productImg1"
        :src="productImg1"
        alt="基于AI的认知智能评估机"
        class="productmatrix-img"
      />
      <div class="superiority" v-if="advantageList.rzpgj.length">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.rzpgj"
          :key="`productmatrix-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
import aiqx from "@/../static/img/product/aiqx.png";

export default {
  data() {
    return {
      product_society_superiority,
      productImg1: aiqx,
      activeName: "",
      advantageList: {
        rzpgj: []
      }
    };
  }
};
</script>
<style lang="less" scoped>
.productmatrix {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .productmatrix-item {
    padding: 0 64px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      text-align: justify;
    }
  }
  .productmatrix-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .productmatrix-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .title {
      width: 100%;
      height: 36px;
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin: 0 50px 32px 0;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/digitization/productmatrix3.vue